import { Controller } from 'stimulus'
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static targets = [ 'mortgage', 'credit', 'output' ]

  connect () {
    const ee = this.creditTarget.value / this.mortgageTarget.value * 100
    const firstAforo = Number((ee).toFixed(1))
    this.toggleWarningText(firstAforo)
    this.outputTarget.textContent = firstAforo + '%'
  }

  updateAforo () {
    const aforo = this.credit() / this.mortgage() * 100
    this.toggleWarningText(aforo)
    this.outputTarget.textContent = Number((aforo).toFixed(1)) + '%'
  }

  mortgage () {
    return AutoNumeric.getAutoNumericElement(this.mortgageTarget).getNumber()
  }

  credit () {
    return AutoNumeric.getAutoNumericElement(this.creditTarget).getNumber()
  }

  toggleWarningText(aforo) {
    if (aforo > 95) {
      if (!this.outputTarget.classList.contains('text-red-600 font-bold')) {
        this.outputTarget.classList.add('text-red-600')
        this.outputTarget.classList.add('font-bold')
      }
    } else {
      this.outputTarget.classList.remove('text-red-600')
      this.outputTarget.classList.remove('font-bold')
    }
  }
}